import RouterSection from '@/Layout/components/RouterSection';

import { checkAuthorization } from '../NavigationGuards';

export default {
  path: '/survey',
  name: 'survey',
  component: RouterSection,
  mode: 'history',
  children: [
    {
      // 서비스 안내
      path: 'serviceinfo',
      name: 'serviceinfo',
      component: () => import('@/views/survey/ServiceInfo'),
    },
    {
      // 일반형 발송 목록
      path: 'defaultsend',
      name: 'defaultsend',
      component: () => import('@/views/survey/defaultSend/index'),
      beforeEnter: checkAuthorization,
    },
    {
      // 추첨형 발송 목록
      path: 'lotterysend',
      name: 'lotterysend',
      component: () => import('@/views/survey/lotterySend/index'),
      beforeEnter: checkAuthorization,
    },
    //설문참여
    {
      // 설문참여
      path: 'respond',
      name: 'respond',
      component: () => import('@/views/survey/temp/index')
    },       
    {      
      // 설문 내역·통계 > 목록 
      path: 'statistics',
      name: 'statistics',
      component: () => import('@/views/survey/statistics/index'),
      beforeEnter: checkAuthorization,
    },
    {
      // 설문 내역·통계 > 상세
      path: 'detail',
      name: 'statisticsdetail',
      component: () => import('@/views/survey/statistics/detail'),
      beforeEnter: checkAuthorization,
    }
  ]
}
